import React, { useEffect } from 'react';
import './lending-partner.css';

const LendingPartner = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="lending-partner-section">
      <div className="container">

        <h2
          className="why-choose-title text-center mb-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Our Lending Partner – <span className="highlight">ACG Leasing Limited</span>
        </h2>

        <p className="lp-intro">
          At Loanontip, we believe in delivering trusted and compliant lending experiences.
          To ensure secure and responsible lending, all loans offered through our platform are
          facilitated by our esteemed lending partner – <strong>ACG Leasing Limited</strong>,
          a company registered with the Reserve Bank of India (RBI) as a Non-Banking Financial Company (NBFC).
        </p>

        <div className="lp-section">
          <h2>About ACG Leasing Limited</h2>
          <p>
            ACG Leasing Limited is a Public Limited Company, incorporated in the late 1990s, under the Companies Act, 1956.
            The company is registered with the Reserve Bank of India (RBI) as a Non-Banking Financial Company (NBFC)
            and operates under the regulatory framework prescribed by the RBI.
          </p>
          <p>
            With over two decades of experience in the financial services industry, ACG Leasing Limited has built a reputation
            for ethical lending, sound risk management, and innovative credit solutions. The company provides customized lending
            products to individuals, small businesses, and professionals, helping them achieve financial stability and growth.
          </p>
          <p>
            Through its customer-centric approach, ACG Leasing Limited has become a trusted name in India’s NBFC ecosystem —
            recognized for promoting responsible lending and financial inclusion across diverse market segments.
          </p>
        </div>

        <div className="lp-section">
          <h2>Our Partnership Model</h2>
          <p>
            The partnership between Loanontip and ACG Leasing Limited brings together digital innovation and regulatory trust
            to simplify the borrowing experience for customers.
          </p>
          <h3>Here’s how it works:</h3>
          <ol>
            <li>
              Loanontip acts as a digital lending platform that facilitates loan applications, customer onboarding,
              KYC verification, and data evaluation through a fully digital interface.
            </li>
            <li>
              ACG Leasing Limited, as the regulated lender, evaluates, approves, and disburses loans directly into the
              customer’s account in accordance with RBI’s Digital Lending Guidelines.
            </li>
            <li>
              Loan servicing, repayment tracking, and customer support are handled in compliance with RBI norms,
              ensuring complete transparency and accountability.
            </li>
          </ol>
          <p>
            This hybrid model ensures borrowers experience both speed and security, without compromising on regulatory compliance.
          </p>
        </div>

        <div className="lp-section">
          <h2>Commitment to Responsible Lending</h2>
          <p>
            Both Loanontip and ACG Leasing Limited are deeply committed to responsible lending practices.
            Every loan application undergoes thorough evaluation to ensure it aligns with the borrower’s financial capacity
            and repayment ability.
          </p>
          <p>
            We promote financial awareness and credit discipline, helping users manage their finances smartly while avoiding over-borrowing.
          </p>
          <h3>All lending activities comply with:</h3>
          <ul>
            <li>RBI’s Fair Practice Code for NBFCs</li>
            <li>RBI’s Digital Lending Guidelines</li>
            <li>Data Privacy and Consent Protocols as per Indian laws</li>
          </ul>
        </div>

        <div className="lp-section disclaimer">
          <h2>Disclaimer</h2>
          <p>
            Loanontip is a digital platform owned and operated by <strong>RRYO Private Limited</strong>.
            The platform connects borrowers with <strong>ACG Leasing Limited</strong>, an RBI-registered NBFC,
            which is the sole entity responsible for loan evaluation, approval, and disbursement.
          </p>
          <p>
            Loanontip does not itself engage in lending or determine loan terms.
            All loans are sanctioned and disbursed directly by ACG Leasing Limited, in compliance with RBI regulations.
          </p>
        </div>

        {/* ✅ Contact Details Section */}
        <div className="lp-section contact-details">
          <h2>Contact Details</h2>
          <p>
            <strong>ACG Leasing Limited</strong><br />
            Regd. Office: A-660, Ground floor, Old No. A 23, Shop No. 1 Giri Marg , Mandawali Fazalpur, East Delhi, East Delhi, East Delhi, Delhi, India, 110092.<br />
            {/* CIN: U65921DL1995PLC073483<br />
            RBI Certificate of Registration No.: 14.00929<br /> */}
            Email: <a href="mailto:info@loanontip.com">info@loanontip.com</a><br />
            Phone: <a href="tel:+917827610061">(+91) 7827610061</a>
          </p>
        </div>

      </div>
    </section>
  );
};

export default LendingPartner;
